import api from '@/plugins/api'

export default {
    async createNotificationToken(token, token_type){
        return await api('/auth/notifications/tokens',{
            method: "POST",
            data: {
                token: token,
                token_type: token_type
            },
            ignoreCode: '*'
        });
    },

    async refreshNotificationToken(oldToken, newToken){
        return await api('/auth/notifications/tokens/' + oldToken, {
            method: "PUT",
            data: {
                token: newToken,
            },
            ignoreCode: '*'
        });
    },

     async destroyNotificationToken(token){
        return await api('/notifications/tokens/' + token, {
            method: "DELETE",
            ignoreCode: '*'
        });
    }
}
